import React from "react";
import moment from "moment";
import { Grid, Typography, IconButton } from "@mui/material";
import ChevronLeftSharpIcon from "@mui/icons-material/ChevronLeftSharp";
import ChevronRightSharpIcon from "@mui/icons-material/ChevronRightSharp";
import { useTheme } from "@mui/material";

interface CalHeadProps {
    month: number;
    year: number;
    prevMonth: () => void;
    nextMonth: () => void;
    onMonthClick: () => void;
}
export default function CalendarHeadDouble(props: CalHeadProps) {
    const theme = useTheme();
    const mo = moment().year(props.year).month(props.month);
    return (
        <div style={{ width: "100%" }}>
            <Grid
                container
                sx={{
                    paddingLeft: theme.spacing(1),
                    paddingRight: theme.spacing(1),
                }}
            >
                <Grid item xs={1}>
                    <IconButton
                        size="small"
                        onClick={props.prevMonth}
                        sx={{ color: "black" }}
                    >
                        <ChevronLeftSharpIcon fontSize="inherit" />
                    </IconButton>
                </Grid>
                <Grid
                    container
                    item
                    xs={10}
                    justifyContent="center"
                    style={{ width: "100%" }}
                >
                    <Typography
                        style={{ cursor: "pointer" }}
                        onClick={props.onMonthClick}
                        variant="h2"
                        display="inline"
                    >
                        {mo.format("MMMM")} {mo.format("YYYY")}
                    </Typography>
                </Grid>
                <Grid item xs={1}>
                    <IconButton
                        size="small"
                        sx={{ color: "black" }}
                        onClick={props.nextMonth}
                    >
                        <ChevronRightSharpIcon fontSize="inherit" />
                    </IconButton>
                </Grid>
            </Grid>
        </div>
    );
}
